<template>
  <b-container fluid>
    <iq-card>
        <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('hospital_configuration.hospital_patient_welfare') }} {{ $t('globalTrans.search')}}</h4>
        </template>
        <template v-slot:body>
        <b-row>
  <b-col lg="3" sm="3">
    <ValidationProvider name="Area Type" vid="hos_area_type_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="hos_area_type_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('org_pro.area_type')}}
        </template>
        <b-form-select
          plain
          v-model="search.hos_area_type_id"
          id="hos_area_type_id"
          :options="getHosAreaTypeList"
          @change="getAreaTypeData(search.area_type_id)"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="3" sm="3">
    <ValidationProvider name="Division" vid="division_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="division_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('externalUser.division')}}
        </template>
        <b-form-select
          plain
          v-model="search.hos_division_id"
          id="division_id"
          :options="getHosDivisionList"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="3" sm="3">
    <ValidationProvider name="District" vid="district_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="district_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('org_pro_district.district')}}
        </template>
        <b-form-select
          plain
          v-model="search.hos_district_id"
          id="district_id"
          :options="getHosDistrictList"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="3" sm="3" v-if="search.hos_area_type_id > 1">
    <ValidationProvider name="Upazila" vid="upazila_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="upazila_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('org_pro_upazilla.upazilla')}}
        </template>
        <b-form-select
          plain
          v-model="search.hos_upazila_id"
          id="upazila_id"
          :options="getHosUpazillaList"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="3" sm="3" v-if="search.hos_area_type_id === 1">
    <ValidationProvider name="City Corporation" vid="city_corporation_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="city_corporation_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('org_pro.city_corporation')}}
        </template>
        <b-form-select
          plain
          v-model="search.hos_city_corporation_id"
          id="city_corporation_id"
          :options="getHosCityCorporationList"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="6" sm="6">
    <ValidationProvider name="Hospital Name" vid="hospital_id">
      <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="hospital_id"
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{ $t('hospital_configuration.hospital_name')}}
        </template>
        <v-select name="Bank"
            v-model="search.hospital_id"
            label="text"
            :reduce="item => item.value"
            :options= hospitalList
            :placeholder="$t('globalTrans.select')"
        />
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
      </b-form-group>
    </ValidationProvider>
  </b-col>
                <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                    <b-form-group
                    class="row"
                    label-cols-sm="12"
                    :label="$t('hospital_configuration.registration_no')"
                    label-for="hospital_name"
                    >
                    <b-form-input
                        id="hospital_name"
                        v-model="search.registration_no"
                        placeholder=""
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                    <b-form-group
                        class="row"
                        label-cols-sm="12"
                        :label="$t('globalTrans.date')"
                        label-for="date"
                        >
                        <b-form-input
                        class="date-picker"
                        v-model="search.reg_date"
                        :placeholder="$t('globalTrans.date')"
                        id="date"
                        >
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" class="text-right">
                    <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
                </b-col>
            </b-row>
        </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('hospital_configuration.hospital_patient_welfares') + ' ' + $t('globalTrans.list')}}</h4>
          </template>
          <template v-slot:headerAction>
            <b-button variant="primary" v-b-modal.modal-4 @click="resetId">
              <i class="fas fa-plus"></i>{{  $t('globalTrans.add_new') }}
            </b-button>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(hospital_name)="data">
                      <span class="capitalize">{{ data.item.hospital_name }}</span>
                    </template>
                    <template v-slot:cell(registration_no)="data">
                      <span class="capitalize">{{ data.item.registration_no }}</span>
                    </template>
                    <template v-slot:cell(reg_date)="data">
                      <span class="capitalize">{{ data.item.reg_date | dateFormat }}</span>
                    </template>
                    <template v-slot:cell(status)="data">
                        <span class="badge badge-danger" v-if="data.item.status == 2">{{$t('globalTrans.inactive')}}</span>
                        <span class="badge badge-success" v-else>{{$t('globalTrans.active')}}</span>
                    </template>
                    <template v-slot:cell(action)="data">
                      <!-- <b-button v-b-modal.modal-4 variant=" iq-bg-success mr-1 mb-1" size="sm" title="Edit" @click="edit(data.item)"><i class="ri-ball-pen-fill m-0"></i></b-button>
                      <b-button :variant="data.item.status === 2 ? ' iq-bg-danger' : ' iq-bg-success'" size="sm" title="Active/Deactive" @click="remove(data.item)">
                        <i class="fas" :class="data.item.status === 2  ? 'fa-toggle-off' : 'fa-toggle-on'"></i>
                      </b-button> -->
                      <a href="javascript:" title="View" class="btn_table_action btn_green" v-b-modal.modal-5 @click="details(data.item)"><i class="fas fa-eye"></i></a>
                      <a href="javascript:" class="btn_table_action btn_blue" v-b-modal.modal-4 title="Edit" @click="edit(data.item)"><i class="ri-ball-pen-fill m-0"></i></a>
                      <a href="javascript:" class="btn_table_action" :class="data.item.status === 2 ? ' btn_rad' : ' btn_green'" title="Active/Deactive" @click="remove(data.item)">
                        <i class="fas" :class="data.item.status === 2  ? 'fa-toggle-off' : 'fa-toggle-on'"></i>
                      </a>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
              <b-modal id="modal-5" size="xl" :title="$t('hospital_configuration.hospital_patient_welfare_details')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
                <b-container fluid>
                    <b-row>
                    <b-col lg="12" sm="12">
                        <iq-card>
                        <template>
                            <b-form>
                            <div class="borderC" style="margin-left: 40px;">
                                <b-row>
                                <b-col>
                                    <span style="color: black;"><strong>{{ $t('hospital_configuration.hos_name') }}</strong> : {{ $i18n.locale === 'bn' ? reg_detail.HospitalBn : reg_detail.HospitalEn}}</span>
                                </b-col>
                                <b-col>
                                    <span style="color: black;"><strong>{{ $t('hospital_configuration.registration_no') }}</strong> :{{ reg_detail.registration_no }}</span>
                                </b-col>
                                </b-row>
                                <b-row>
                                <b-col>
                                    <span style="color: black;"><strong>{{ $t('globalTrans.date') }}</strong> :{{ reg_detail.reg_date | dateFormat }}</span>
                                </b-col>
                                <b-col>
                                    <span style="color: black;"><strong>{{ $t('user.mobile_no') }}</strong> :{{ reg_detail.mobile_no | mobileNumber }}</span>
                                </b-col>
                                </b-row>
                                <b-row>
                                <b-col>
                                    <span style="color: black;"><strong>{{ $t('globalTrans.email') }}</strong> :{{ reg_detail.email }}</span>
                                </b-col>
                                </b-row>
                            </div><br>
                            </b-form>
                        </template>
                        </iq-card>
                    </b-col>
                    </b-row>
                </b-container>
                </b-modal>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-4" size="lg" :title="formTitle" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <p>
        <FormV :id="editItemId" :key="editItemId" :item="item"/>
      </p>
    </b-modal>
  </b-container>
</template>
<script>
import FormV from './Form'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { patientWelfareListApi, patientWelfareToggleStatusApi, hospitaListPdfApi, assignUserHospitalApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import Custom from '../../../../../store/custom'
import flatpickr from 'flatpickr'
export default {
    mixins: [ModalBaseMasterList],
    components: {
        FormV
    },
    data () {
        return {
            reg_detail: '',
            hospitalList: [],
            search: {
                hos_area_type_id: 0,
                hos_division_id: 0,
                hos_district_id: 0,
                hos_upazila_id: 0,
                hos_city_corporation_id: 0,
                hospital_id: '',
                registration_no: '',
                reg_date: ''
            },
            editItemId: '',
            item: '',
            rows: [],
            districtList: [],
            upazilaList: [],
            unionList: [],
            hospitalIds: [],
            userId: 0,
            hospitalLoad: false,
            cityCorporationList: [],
            hospital_id_arr: [],
            pauroshobaList: []
        }
    },
    computed: {
        formTitle () {
            return (this.editItemId === 0) ? this.$t('hospital_configuration.hospital_patient_welfare') + ' ' + this.$t('globalTrans.entry') : this.$t('hospital_configuration.hospital_patient_welfare') + ' ' + this.$t('globalTrans.modify')
        },
        getHosDivisionList: function () {
            return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
        },
        getHosDistrictList: function () {
            return this.$store.state.commonObj.districtList.filter(item => item.status === 0 && item.division_id === this.search.hos_division_id)
        },
        getHosCityCorporationList: function () {
            return this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === this.search.hos_district_id)
        },
        getHosUpazillaList: function () {
            return this.$store.state.commonObj.upazilaList.filter(item => item.status === 0 && item.district_id === this.search.hos_district_id)
        },
        getHosAreaTypeList: function () {
            const objectData = this.$store.state.commonObj.wardTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.id, text: obj.name_bn }
                } else {
                    return { value: obj.id, text: obj.name }
                }
            })
        },
        columns () {
            const labels = [
                { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
                { label: this.$t('hospital_configuration.hos_name'), class: 'text-left' },
                { label: this.$t('hospital_configuration.registration_no'), class: 'text-left' },
                { label: this.$t('globalTrans.date'), class: 'text-left' },
                { label: this.$t('globalTrans.status'), class: 'text-center' },
                { label: this.$t('globalTrans.action'), class: 'text-center' }
            ]

            let keys = []

            if (this.$i18n.locale === 'bn') {
                keys = [
                    { key: 'index' },
                    { key: 'HospitalBn' },
                    { key: 'registration_no' },
                    { key: 'reg_date' },
                    { key: 'status' },
                    { key: 'action' }
                ]
            } else {
                keys = [
                    { key: 'index' },
                    { key: 'HospitalEn' },
                    { key: 'registration_no' },
                    { key: 'reg_date' },
                    { key: 'status' },
                    { key: 'action' }
                ]
            }

            return labels.map((item, index) => {
                return Object.assign(item, keys[index])
            })
        }
    },
    watch: {
        loadingState: function (newVal, oldVal) {
        if (newVal) {
            this.loadData()
        }
        },
        'search.hos_area_type_id': function () {
            this.hospitalList = this.getHospitalList()
        },
        'search.hos_division_id': function () {
            this.hospitalList = this.getHospitalList()
        },
        'search.hos_district_id': function () {
            this.hospitalList = this.getHospitalList()
        },
        'search.hos_upazila_id': function () {
            this.hospitalList = this.getHospitalList()
        },
        'search.hos_city_corporation_id': function () {
            this.hospitalList = this.getHospitalList()
        },
        'search.hospital_id': function (newVal, oldVal) {
        if (newVal && oldVal !== 0) {
            this.search.department_id = 0
            this.search.hos_ward_id = 0
            const hospital = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.find(item => item.value === parseInt(newVal))
            this.search.hos_area_type_id = hospital.area_type_id ? hospital.area_type_id : 0
            this.search.hos_division_id = hospital.division_id ? hospital.division_id : 0
            this.search.hos_district_id = hospital.district_id ? hospital.district_id : 0
            this.search.hos_upazila_id = hospital.upazilla_id ? hospital.upazilla_id : 0
            this.search.hos_city_corporation_id = hospital.city_corporation_id ? hospital.city_corporation_id : 0
            }
            if (newVal < 1) {
            this.search.hos_area_type_id = 0
            this.search.hos_division_id = 0
            this.search.hos_district_id = 0
            this.search.hos_upazila_id = 0
            this.search.hos_city_corporation_id = 0
            }
        }
    },
    created () {
        this.hospitalLoad = true
        var officeId = this.$store.state.Auth.authUser.office_id
        if (officeId > 1) {
            this.userId = this.$store.state.Auth.authUser.user_id
            if (this.userId > 1) {
                this.getUserWiseHospital(this.userId)
            }
        } else {
            this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
                this.hospitalIds.push(obj.value)
            })
            this.loadData()
            this.hospitalList = this.getHospitalList()
        }
    },
    mounted () {
        flatpickr('.date-picker', {})
    },
    methods: {
        async getUserWiseHospital (userId) {
        const params = Object.assign({ user_id: userId })
        const result = await RestApi.getData(hospitalServiceBaseUrl, assignUserHospitalApi, params)
        if (result.success) {
                this.hospitalIds = result.data
        } else {
              this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
                  this.hospitalIds.push(obj.value)
              })
        }
        this.loadData()
        this.hospitalList = this.getHospitalList()
    },
    getHospitalList () {
        let hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
        if (this.hospitalIds.length > 0) {
        hospitalList = hospitalList.filter((p) => this.hospitalIds.includes(p.value))
        }
        this.hospitalLoad = false
        if (this.search.hos_area_type_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.area_type_id === this.search.hos_area_type_id)
        }

        if (this.search.hos_category > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.category === this.search.hos_category)
        }

        if (this.search.hos_division_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.division_id === this.search.hos_division_id)
        }

        if (this.search.hos_district_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.district_id === this.search.hos_district_id)
        }

        if (this.search.hos_city_corporation_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.city_corporation_id === this.search.hos_city_corporation_id)
        }
        return hospitalList
    },
    getAreaTypeData (typeId) {
      this.ItemShow = true
      if (typeId === 1) {
          this.CityCorpItemShow = true
          this.PauroshobaItemShow = false
          this.UnionItemShow = false
      } else if (typeId === 2) {
          this.CityCorpItemShow = false
          this.PauroshobaItemShow = true
          this.UnionItemShow = false
      } else if (typeId === 3) {
          this.CityCorpItemShow = false
          this.PauroshobaItemShow = false
          this.UnionItemShow = true
      }
    },
        details (item) {
            this.reg_detail = item
        },
        searchData () {
            this.loadData()
        },
        edit (item) {
            this.editItemId = item.id
            this.item = item
        },
        remove (item) {
            this.changeStatus(hospitalServiceBaseUrl, patientWelfareToggleStatusApi, item, 'hospital', 'hospitalInfoList')
        },
        loadData () {
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
            RestApi.getData(hospitalServiceBaseUrl, patientWelfareListApi, params).then(response => {
                if (response.success) {
                    var result = response.data.data
                    var thiss = this.$store
                    result.forEach(function (element) {
                        element.HospitalEn = thiss.state.HospitalDisabilityService.commonObj.hospitalInfoList.find(item => item.value === element.hospital_id).text_en
                        element.HospitalBn = thiss.state.HospitalDisabilityService.commonObj.hospitalInfoList.find(item => item.value === element.hospital_id).text_bn
                    })
                    this.$store.dispatch('setList', this.getRelationalData(response.data.data))
                    this.paginationData(response.data)
                }
                this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
            })
            RestApi.getData(hospitalServiceBaseUrl, hospitaListPdfApi, params).then(response => {
                if (response.success) {
                    this.hospitalPdfData = response.data
                }
            })
        },
        getRelationalData (data) {
            let tmpDivision = {}
            let tmpDistrict = {}
            let tmpUpzila = {}
            let tmpAreaType = {}
            let hospitalCategory = {}
            const listData = data.map(item => {
                tmpDivision = this.$store.state.commonObj.divisionList.find(division => division.value === item.division_id && division.status === 0)
                tmpDistrict = this.$store.state.commonObj.districtList.find(district => district.value === item.district_id && district.status === 0)
                tmpUpzila = this.$store.state.commonObj.upazilaList.find(upazilla => upazilla.value === item.upazila_id && upazilla.status === 0)
                tmpAreaType = Custom.wardTypeList.find(areaType => areaType.id === item.area_type_id)
                hospitalCategory = this.$store.state.HospitalDisabilityService.commonObj.hospitalCategoryList.find(category => category.id === item.category)
                const orgData = {
                    hospital_name: item.hospital_name !== undefined ? item.hospital_name : '',
                    hospital_name_bn: item.hospital_name_bn !== undefined ? item.hospital_name_bn : '',
                    division_name: tmpDivision !== undefined ? tmpDivision.text_en : '',
                    division_name_bn: tmpDivision !== undefined ? tmpDivision.text_bn : '',
                    district_name: tmpDistrict !== undefined ? tmpDistrict.text_en : '',
                    district_name_bn: tmpDistrict !== undefined ? tmpDistrict.text_bn : '',
                    upazilla_name: tmpUpzila !== undefined ? tmpUpzila.text_en : '',
                    upazilla_name_bn: tmpUpzila !== undefined ? tmpUpzila.text_bn : '',
                    area_type_name: tmpAreaType !== undefined ? tmpAreaType.name : '',
                    area_type_name_bn: tmpAreaType !== undefined ? tmpAreaType.name_bn : '',
                    hospital_category_en: hospitalCategory !== undefined ? hospitalCategory.name : '',
                    hospital_category_bn: hospitalCategory !== undefined ? hospitalCategory.name_bn : ''

                }
                return Object.assign({}, item, orgData)
            })
            return listData
        }
    }
}
</script>
